import { render, staticRenderFns } from "./main-requests-tab.vue?vue&type=template&id=b4cd914a&scoped=true&"
import script from "./main-requests-tab.vue?vue&type=script&lang=js&"
export * from "./main-requests-tab.vue?vue&type=script&lang=js&"
import style0 from "./main-requests-tab.vue?vue&type=style&index=0&id=b4cd914a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cd914a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VIcon,VRow})
